import { createUseStyles } from 'react-jss';

const styles = {
  dropdownButton: {
    fontWeight: 700,
    padding: '0 1rem',
    fontSize: '1.6rem',
    lineHeight: '2.6rem',
  },
  dropdownOpenedBtn: {
    border: '2px solid transparent',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
